// Get jQuery from global scope
const $ = window.jQuery;

// Mobile navigation (vanilla JS — no jQuery dependency so the menu still works
// even if jQuery fails to load).
function initMobileNavigation() {
  const mobileNav = document.querySelector(".mobile-navigation");
  const hamburger = document.querySelector(".hamburger");
  if (!mobileNav || !hamburger) return;

  let scrollTop = 0;
  let scrollLeft = 0;

  function disableScroll() {
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
  }

  function enableScroll() {
    window.onscroll = function () {};
  }

  function closeMenu() {
    mobileNav.classList.remove("is-open");
    document.body.classList.remove("menu-open");
    hamburger.setAttribute("aria-expanded", "false");
    hamburger.setAttribute("aria-label", "Open navigation menu");
    enableScroll();
  }

  hamburger.addEventListener("click", function (event) {
    event.preventDefault();
    const willOpen = !mobileNav.classList.contains("is-open");
    mobileNav.classList.toggle("is-open", willOpen);
    document.body.classList.toggle("menu-open", willOpen);
    hamburger.setAttribute("aria-expanded", willOpen ? "true" : "false");
    hamburger.setAttribute(
      "aria-label",
      willOpen ? "Close navigation menu" : "Open navigation menu",
    );
    if (willOpen) {
      disableScroll();
    } else {
      enableScroll();
    }
  });

  const backdrop = mobileNav.querySelector(".mobile-navigation__backdrop");
  if (backdrop) {
    backdrop.addEventListener("click", closeMenu);
  }

  // Mark items that have a submenu so CSS / carets can target them.
  mobileNav.querySelectorAll("li").forEach(function (li) {
    if (li.querySelector("ul")) li.classList.add("has-sub");
  });

  // Animate a submenu open/closed by transitioning max-height.
  function slideDown(el, duration) {
    el.style.display = "block";
    el.style.overflow = "hidden";
    el.style.maxHeight = "0px";
    el.style.transition = `max-height ${duration}ms ease`;
    const target = el.scrollHeight;
    // force a reflow so the transition picks up the change
    void el.offsetHeight;
    el.style.maxHeight = target + "px";
    window.setTimeout(function () {
      el.style.maxHeight = "";
      el.style.overflow = "";
      el.style.transition = "";
    }, duration);
  }

  function slideUp(el, duration) {
    el.style.overflow = "hidden";
    el.style.maxHeight = el.scrollHeight + "px";
    el.style.transition = `max-height ${duration}ms ease`;
    void el.offsetHeight;
    el.style.maxHeight = "0px";
    window.setTimeout(function () {
      el.style.display = "";
      el.style.maxHeight = "";
      el.style.overflow = "";
      el.style.transition = "";
    }, duration);
  }

  function siblings(el) {
    return Array.from(el.parentNode.children).filter(function (c) {
      return c !== el;
    });
  }

  const carets = mobileNav.querySelectorAll(
    ".mobile-navigation__inner .mobile-navigation__caret.trigger-caret",
  );
  carets.forEach(function (caret) {
    caret.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const li = caret.parentElement;
      if (!li) return;

      const duration = 350;

      if (li.classList.contains("is-open")) {
        li.classList.remove("is-open");
        li.querySelectorAll("li.is-open").forEach(function (n) {
          n.classList.remove("is-open");
        });
        li.querySelectorAll("ul").forEach(function (ul) {
          slideUp(ul, duration);
        });
      } else {
        li.classList.add("is-open");
        Array.from(li.children)
          .filter(function (c) {
            return c.tagName === "UL";
          })
          .forEach(function (ul) {
            slideDown(ul, duration);
          });

        siblings(li).forEach(function (sibling) {
          sibling.classList.remove("is-open");
          sibling.querySelectorAll("li.is-open").forEach(function (n) {
            n.classList.remove("is-open");
          });
          sibling.querySelectorAll("ul").forEach(function (ul) {
            slideUp(ul, duration);
          });
        });
      }
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMobileNavigation);
} else {
  initMobileNavigation();
}

$(document).ready(function () {
  // Top banner auto-scroll - optimized to batch DOM reads
  function initTopBannerSlider() {
    const $banner = $(".top-banner__slider");
    if (!$banner.length) return;

    const $content = $banner.parent();

    // Batch all DOM reads at once to prevent forced reflows
    let contentWidth, screenWidth;
    requestAnimationFrame(() => {
      contentWidth = $banner.outerWidth();
      screenWidth = $(window).width();

      // Calculate how many clones we need to fill screen + extra for smooth loop
      const clonesNeeded = Math.ceil(screenWidth / contentWidth) + 2;

      // Create multiple clones for seamless infinite scroll
      for (let i = 0; i < clonesNeeded; i++) {
        const $clone = $banner.clone();
        $content.append($clone);
      }

      let position = 0;
      const speed = 0.75; // pixels per frame

      function animate() {
        position -= speed;

        // Reset position for seamless loop
        if (Math.abs(position) >= contentWidth) {
          position = 0;
        }

        $content.css("transform", `translateX(${position}px)`);
        requestAnimationFrame(animate);
      }

      animate();
    });
  }

  // Initialize on load
  initTopBannerSlider();

  // Handle logged-in header position on scroll
  if ($("body").hasClass("logged-in")) {
    $(window).on("scroll", function () {
      if ($(window).scrollTop() > 0) {
        $("body").addClass("scrolled");
      } else {
        $("body").removeClass("scrolled");
      }
    });
  }

  // Add sticky class to header on scroll
  $(window).on("scroll", function () {
    if ($(window).scrollTop() > 0) {
      $("header").addClass("sticky");
    } else {
      $("header").removeClass("sticky");
    }
  });

  // Add 'sub-four' class to submenus with fewer than 4 items
  $(".header-content-wrapper nav ul li.menu-item-has-children .sub-menu").each(
    function () {
      const itemCount = $(this).children("li").length;
      if (itemCount < 4) {
        $(this).addClass("sub-four");
      }
    },
  );
});

// Use jQuery to listen for Gravity Forms event
$(document).on("gform_confirmation_loaded", function (event, formId) {
  console.log("gform_confirmation_loaded event fired");
  console.log("Form submitted successfully - Form ID:", formId);
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "gf_form_success",
    form_id: formId,
  });
});
